import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react';

// Blank out the "No description" placeholder the scaffolder shows for templates
// (and their wizard) that have no `metadata.description`.
const scaffolderReactMessages = createTranslationMessages({
  ref: scaffolderReactTranslationRef,
  messages: {
    'workflow.noDescription': '',
    'templateCard.noDescription': '',
  },
});

export const scaffolderTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    TranslationBlueprint.make({
      name: 'scaffolder-react-no-description',
      params: { resource: scaffolderReactMessages },
    }),
  ],
});
